import React, { useEffect } from 'react';
import { styled } from '@compiled/react';
import { Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import UnarchiveIssueModal from '@atlassian/jira-unarchive-modal/src/async.tsx';
import { useArchiveIssueActions } from '../controllers/main.tsx';
import { useArchiveIssueStates } from '../controllers/selectors.tsx';
import { ArchivesTableEmptyState } from './archives-table/empty-state/main.tsx';
import ErrorState from './error-state/index.tsx';
import { Filters } from './filter/index.tsx';
import Header from './header/main.tsx';
import ArchivesMain from './main.tsx';
import { IssueManageBar } from './manage-bars/main.tsx';
import Search from './search/index.tsx';
import { LayoutMainWrapper } from './styled.tsx';

const Archives = () => {
	const { archivesIssueDataPresent } = useArchiveIssueStates();
	const { setArchivesIssueDataPresent } = useArchiveIssueActions();

	useEffect(() => {
		return () => {
			// this is to make sure whenever we have empty state and user comes back to same route and fetch back results.
			!archivesIssueDataPresent && setArchivesIssueDataPresent(true);
		};
	}, [archivesIssueDataPresent, setArchivesIssueDataPresent]);

	return (
		<JSErrorBoundary
			id="jiraArchiveIssuesPage"
			packageName="jiraIssueArchivalArchives"
			fallback={() => <ErrorState />}
		>
			<ContextualAnalyticsData sourceType={SCREEN} sourceName="archivesPage">
				<LayoutMainWrapper>
					<Header
						bottomBar={
							archivesIssueDataPresent === false ? null : (
								<Flex justifyContent="space-between">
									<Search />
									<Filters />
								</Flex>
							)
						}
					/>
					{archivesIssueDataPresent === false ? (
						<ArchivesTableEmptyState noDataState />
					) : (
						<ContentWrapper>
							<ArchivesMain />
							<IssueManageBar />
							<UnarchiveIssueModal />
						</ContentWrapper>
					)}
				</LayoutMainWrapper>
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const ContentWrapper = styled.div({
	padding: `0 ${token('space.500', '40px')} 0`,
	flex: 1,
	marginBottom: token('space.400', '32px'),
});

export default Archives;
